<app-header [pageTitle]="pageTitle" (back)="backToLeaveSyndicate()"></app-header>
<ion-content>
  <div class="upper-content-wrapper">
    <p class="tom-syndicate">{{ syndicate?.syndicate_name }}</p>
  </div>
  <div class="lower-content-wrapper">
    <div class="reason-content">
      <p>{{'syndicate-leave-final.sorry' | translate}}</p>
      <p>{{'syndicate-leave-final.remember' | translate}}</p>
      <ul class="first-row">
        <li>{{'syndicate-leave-final.leavingsyndicate' | translate}}</li>
        <li>{{'syndicate-leave-final.alreadypurchased' | translate}}</li>
        <li>{{'syndicate-leave-final.accessfollowing' | translate}}
          <ul class="inner-row">
            <li>{{'syndicate-leave-final.UnplayedGames' | translate}}</li>
            <li>{{'syndicate-leave-final.rewardpoints' | translate}}</li>
            <li>{{'syndicate-leave-final.bonuscredit' | translate}}</li>
            <li>{{'syndicate-leave-final.cashbalances' | translate}}.</li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="checkbox-row">
      <div class="check-box">
        <ion-checkbox mode="md" color="secondary" slot="start" [ngClass]="{'ischecked': !isChecked && count!=0}"
          (ionChange)="onCheck($event)" class="signupcheck" aria-label="confirm" aria-labelledby="ion-cb-0-lbl"
          type="checkbox"></ion-checkbox>
      </div>
      <p class="accepttext"> {{'syndicate-leave-final.box' | translate}}</p>
    </div>
    <div class="errorContainer">
      <ion-icon name="warning" class="icon"></ion-icon>
      <span class="text"><b>{{'syndicate-leave-final.action' | translate}}</b></span>
    </div>
  </div>
</ion-content>
<ion-row class="lower-most-content">
  <ion-col class="still-leave-wrap">
    <p class="still-leave" (click)="leaveFinal()">{{'syndicate-leave-final.Leave permanently' | translate}}</p>
  </ion-col>
</ion-row>